app.service('basketProduct', function (console, orderUtils, basketUtils, message, modal, basketAnalytics) {
	function removeSuite(itemId, focusParams) {
		console.log('USUWANIE ZESTAWU');
		basketAnalytics.removeItem({itemId: itemId});
		basketUtils.skipValidation();
		basketUtils.incBacks();
		$('#F_SELECTED_ITEM').val(itemId);
		orderUtils.send('DELETE_ITEM', true, focusParams);
	}
	function confirmChangeBundle(type, mainId, callback) {
		const html = $('#product-bundle-' + type + '-' + mainId).html();
		if(html && html.length){
			if(type == 'decrease'){
				modal.generate({
					id: 'remove-bundle-confirmation',
					content: html,
					buttons: [
						{
							text: 'Anuluj',
							click: function () {
								modal.close();
							},
							cssClass: 'btn-third'
						},
						{
							text: 'Zmniejsz liczbę sztuk',
							click: function () {
								modal.close();
								callback && callback();
							},
							cssClass: 'btn-second'
						}
					]
				});
			} else if(type == 'remove'){
				modal.generate({
					id: 'remove-bundle-confirmation',
					content: html,
					buttons: [
						{
							text: 'Anuluj',
							click: function () {
								modal.close();
							},
							cssClass: 'btn-third'
						},
						{
							text: 'Usuń produkty',
							click: function () {
								modal.close();
								callback && callback();
							},
							cssClass: 'btn-second'
						}
					]
				});
			} else if(type == 'add'){
				modal.generate({
					id: 'remove-bundle-confirmation',
					content: html,
					buttons: [
						{
							text: 'Rozumiem',
							click: function () {
								modal.close();
							},
							cssClass: 'btn-second'
						},
					]
				});
			}
		} else {
			console.log('Brak informacji o produkcie w bundle, nie można wyświetlić warstwy');
		}
	}
	function confirmRemoveDependent(itemId, callback) {
		const html = $('#product-dependent-remove-' + itemId).html();
		if(html && html.length){
			modal.generate({
				id: 'remove-dependent-confirmation',
				content: html,
				buttons: [
					{
						text: 'Anuluj',
						click: function () {
							modal.close();
						},
						cssClass: 'btn-third'
					},
					{
						text: 'Usuń produkt',
						click: function () {
							modal.close();
							callback && callback();
						},
						cssClass: 'btn-second'
					}
				]
			});
		} else {
			console.log('Brak informacji o produkcie zależnym, nie można wyświetlić warstwy');
			callback && callback();
		}
	}
	function remove(itemId, isBundle=false, isDependent=false, focusParams) {
		if(isBundle){
			confirmChangeBundle('remove', itemId, function(){
				remove(itemId, false, isDependent, focusParams);
			});
			return;
		}
		if(isDependent){
			confirmRemoveDependent(itemId, function(){
				remove(itemId, isBundle, false, focusParams);
			});
			return;
		}
		console.log('USUWANIE PRODUKTU');
		basketAnalytics.removeItem({itemId: itemId});
		basketUtils.skipValidation();
		basketUtils.incBacks();
		$('#F_SELECTED_ITEM').val(itemId);
		orderUtils.send('DELETE_ITEM', true, focusParams);
	}
	function increase(value, mainId, focusParams) {
		change(value, mainId, 'increase', focusParams);
	}
	function decrease(value, mainId, focusParams) {
		change(value, mainId, 'decrease', focusParams);
	}
	
	function change(value, mainId, action, focusParams) {
		function changeForce(warrantyChanged) {
			$input.val(value);
			if ($productInput.length) {
				basketAnalytics.changeQuantity({
					itemId: mainId, 
					quantity: parseInt(value),
					warrantyChanged: warrantyChanged
				});
				$productInput.val(value)//.change();
				basketUtils.calculateCart(focusParams);
			} else {
				modal.alert('Błąd zmiany ilości. Prosimy spróbować później');
			}
		}
		const $warrantyInput = $('#warranty-' + mainId);
		const $productInput = $('#product-' + mainId);
		const $input = $('input.js-change-quantity[data-main="' + mainId + '"]').first();
		const isBundle = $input.data('bundle-remove');
		
		if(isBundle && action === 'decrease'){
			confirmChangeBundle('decrease', mainId, function(){
				$input.data('bundle-remove', false);
				change(value, mainId, action, focusParams);
			});
			return;
		} 
		if ($warrantyInput.length && value > $warrantyInput.val() / 1) {
			message.get('cart.bhtmlCheckWarranty').then(function (text) {
				modal.generate({
					id: 'modal-change-quantity',
					content: '<h2>' + text + '</h2>',
					buttons: [
						{
							text: 'Tak',
							click: function () {
								modal.close(false);
								$warrantyInput.val(value);
								changeForce(true);
							},
							cssClass: 'btn-second'
						},
						{
							text: 'Nie',
							click: function () {
								modal.close(false);
								changeForce(false);
							},
							cssClass: 'btn-third'
						}
					]
				})
			});
		} else {
			changeForce(false);
		}
	}

	return {
		remove,
		removeSuite,
		change,
		increase,
		decrease,
		maxBundleQuantity: function(mainId){
			confirmChangeBundle('add', mainId)
		}
	};
});
